import { Button } from '@ntconsult/aluma-react';
import { Download } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { SpreadsheetExport } from '../hooks/useSpreadsheetExport';
import type { ScopedExportRequest } from '../types/Filters';
import { ExportModal, type ExportModalLabels } from './ExportModal';

type ExportButtonProps = {
  /** Cada tela decide o que vai no arquivo. */
  exportMutation: SpreadsheetExport<ScopedExportRequest>;
  disabled: boolean;
  labels: ExportModalLabels;
};

/** Abre o `ExportModal`: todas as páginas ou só a da tela, em Excel ou CSV. */
export function ExportButton({ exportMutation, disabled, labels }: ExportButtonProps) {
  const { t } = useTranslation('alocacao');
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="secondary"
        size="sm"
        leftIcon={<Download size={14} />}
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        {t('exportacao.botao')}
      </Button>
      <ExportModal
        open={open}
        onClose={() => setOpen(false)}
        exportMutation={exportMutation}
        labels={labels}
      />
    </>
  );
}
